module.exports = __webpack_public_path__ + "img/peopleman.b0da11af.png";